var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row new-allocation-panel",
    attrs: {
      "id": "new-allocation-panel"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Allocation Panel")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "tabs-active"
  }, [_c('b-tabs', {
    staticClass: "NewAllocationtab",
    attrs: {
      "content-class": "mt-3"
    },
    model: {
      value: (_vm.ActiveTabIndex),
      callback: function($$v) {
        _vm.ActiveTabIndex = $$v
      },
      expression: "ActiveTabIndex"
    }
  }, [(_vm.IsDelivery) ? _c('b-tab', {
    attrs: {
      "title": "FWD"
    }
  }, [(_vm.ActiveTabIndex == 0) ? _c('forward-allocation') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.IsRVP) ? _c('b-tab', {
    attrs: {
      "title": "RVP"
    }
  }, [(_vm.ActiveTabIndex == 1) ? _c('Reverse-allocation') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.IsRVP && !_vm.IsDelivery) ? _c('b-tab', {
    attrs: {
      "title": "Allocation Panel is not available for this HUB,Kindly reach out to Tech Support"
    }
  }) : _vm._e()], 1)], 1)])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e08fe4fe","hasScoped":true}!./src/views/components/newallocationpage/newallocationpage.component.html
// module id = 1498
// module chunks = 1